import { render, staticRenderFns } from "./LiveSettingTab.vue?vue&type=template&id=5818ee0c&scoped=true&"
import script from "./LiveSettingTab.vue?vue&type=script&lang=js&"
export * from "./LiveSettingTab.vue?vue&type=script&lang=js&"
import style0 from "./LiveSettingTab.vue?vue&type=style&index=0&id=5818ee0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818ee0c",
  null
  
)

export default component.exports